/**
 * Opens Storepoint map in a modal; loads third-party script on first open.
 */
(function () {
  if (window.__kdStorepointModalBound) return;
  window.__kdStorepointModalBound = true;

  function moveModalsToBody() {
    document.querySelectorAll('.kd-storepoint-modal').forEach(function (modal) {
      if (modal.parentNode !== document.body) {
        document.body.appendChild(modal);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveModalsToBody);
  } else {
    moveModalsToBody();
  }

  function loadStorepoint(mapId) {
    if (!mapId) return;
    var sel = 'script[data-storepoint-map-id="' + mapId + '"]';
    if (document.querySelector(sel)) return;

    var a = document.createElement('script');
    a.type = 'text/javascript';
    a.async = true;
    a.src = 'https://cdn.storepoint.co/api/v1/js/' + mapId + '.js';
    a.setAttribute('data-storepoint-map-id', mapId);
    var b = document.getElementsByTagName('script')[0];
    b.parentNode.insertBefore(a, b);
  }

  function openModal(modal) {
    if (!modal) return;
    var host = modal.querySelector('[data-storepoint-map-host]');
    var mapId = host && host.getAttribute('data-map-id');
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('kd-storepoint-modal-open');
    if (mapId) loadStorepoint(mapId);
    var closeBtn = modal.querySelector('[data-storepoint-close]');
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kd-storepoint-modal-open');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-storepoint-open]');
    if (openBtn) {
      e.preventDefault();
    var id = openBtn.getAttribute('aria-controls');
    var modal = id ? document.getElementById(id) : document.querySelector('.kd-storepoint-modal');
    if (modal) openModal(modal);
      return;
    }

    var closeHit = e.target.closest('[data-storepoint-close]');
    if (closeHit) {
      e.preventDefault();
      closeModal(closeHit.closest('.kd-storepoint-modal'));
      return;
    }

    if (e.target.classList.contains('kd-storepoint-modal__backdrop')) {
      closeModal(e.target.closest('.kd-storepoint-modal'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.kd-storepoint-modal.is-open').forEach(closeModal);
  });

  document.addEventListener('shopify:section:load', moveModalsToBody);

  document.addEventListener('shopify:section:unload', function (ev) {
    var sid = ev.detail && ev.detail.sectionId;
    if (!sid) return;
    var modal = document.getElementById('kd-storepoint-modal-' + sid);
    if (modal) modal.remove();
  });
})();
